import type { ComponentProps } from 'react';

import CaretDown from '@decisiv/iconix/lib/components/CaretDown';
import CaretUp from '@decisiv/iconix/lib/components/CaretUp';

import type SearchableFilter from 'components/SearchableFilter';

/**
 * SearchableFilter look of the PD-5874 Fleet Management toolbars (All Teams
 * and the Team page): the borderless secondary filter with the filled caret
 * of the Figma, instead of the default bordered filter with a chevron.
 */
const TOOLBAR_FILTER_PROPS: Pick<
  ComponentProps<typeof SearchableFilter>,
  'kind' | 'CollapsedIcon' | 'ExpandedIcon'
> = {
  kind: 'secondary',
  CollapsedIcon: CaretDown,
  ExpandedIcon: CaretUp,
};

export default TOOLBAR_FILTER_PROPS;
